<template>
    <div class="component-content">
      <el-button class="rc-button" type="text" :style="{'width':'100%','height':'100%','display':'flex','justify-content':component.properties.justifyContent,'align-items':component.properties.alignItems,'font-weight':component.properties.fontWeight}">{{initComponent.name}}</el-button>
    </div>
</template>

<script>
import { componentMixin } from '../mixins'
export default {
  name: 'rc-button',
  props: ['initComponent'],
  mixins: [ componentMixin ],
  data () {
    return {
      component: this.initComponent
    }
  }
}
</script>
<style lang="scss">
.rc-button span{
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/form/components/button/rc-button.vue